var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 414,
    height: 498,
    viewBox: "0 0 414 498",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M66.6379 61.8496C73.8618 25.7519 106.217 0.233719 143.004 1.62004L340.919 9.07844C386.167 10.7836 419.597 51.8895 412.044 96.5348L354.978 433.879C348.272 473.517 311.505 500.819 271.621 495.777L66.9485 469.9C23.7534 464.439 -5.72988 423.468 2.81381 380.775L66.6379 61.8496Z",
    stroke: "#CEB294",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "7.5 7.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashes);
export default __webpack_public_path__ + "static/media/dashes.f4cf54e1511577a71b93f2f835459910.svg";
export { ForwardRef as ReactComponent };